var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 44,
    viewBox: "0 0 149 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147.5,
    height: 43,
    rx: 4.5,
    stroke: "url(#paint0_linear_3536_5104)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9496 23.9264C72.3624 23.9264 70.2537 25.8943 70.2537 28.6047C70.2537 31.2986 72.3624 33.283 74.9496 33.283C77.5379 33.283 79.6466 31.2986 79.6466 28.6047C79.6455 25.8943 77.5368 23.9264 74.9496 23.9264ZM74.9496 31.4416C73.5317 31.4416 72.3096 30.2723 72.3096 28.6058C72.3096 26.9217 73.5328 25.77 74.9496 25.77C76.3675 25.77 77.5896 26.9217 77.5896 28.6058C77.5896 30.2712 76.3675 31.4416 74.9496 31.4416ZM64.7042 23.9264C62.117 23.9264 60.0083 25.8943 60.0083 28.6047C60.0083 31.2986 62.117 33.283 64.7042 33.283C67.2925 33.283 69.4012 31.2986 69.4012 28.6047C69.4012 25.8943 67.2925 23.9264 64.7042 23.9264ZM64.7042 31.4416C63.2863 31.4416 62.0642 30.2723 62.0642 28.6058C62.0642 26.9217 63.2874 25.77 64.7042 25.77C66.1221 25.77 67.3442 26.9217 67.3442 28.6058C67.3453 30.2712 66.1221 31.4416 64.7042 31.4416ZM52.5184 25.363V27.3474H57.2682C57.1263 28.4639 56.7545 29.279 56.1869 29.8455C55.4961 30.5363 54.4148 31.2986 52.5184 31.2986C49.5946 31.2986 47.3088 28.9413 47.3088 26.0175C47.3088 23.0937 49.5946 20.7364 52.5184 20.7364C54.0958 20.7364 55.2475 21.3568 56.0978 22.1543L57.4981 20.754C56.3101 19.6199 54.7338 18.752 52.5184 18.752C48.5133 18.752 45.1462 22.0124 45.1462 26.0175C45.1462 30.0226 48.5133 33.283 52.5184 33.283C54.6799 33.283 56.3112 32.5735 57.5861 31.2447C58.8973 29.9335 59.3054 28.0899 59.3054 26.6016C59.3054 26.1418 59.2702 25.7161 59.1987 25.3619H52.5184V25.363ZM102.357 26.9041C101.968 25.8591 100.78 23.9264 98.3521 23.9264C95.942 23.9264 93.9389 25.8228 93.9389 28.6047C93.9389 31.2271 95.9244 33.283 98.582 33.283C100.726 33.283 101.967 31.9718 102.481 31.2095L100.886 30.1458C100.355 30.9257 99.6281 31.4394 98.582 31.4394C97.537 31.4394 96.7923 30.9609 96.3138 30.0215L102.569 27.4343L102.357 26.9041ZM95.9772 28.4639C95.9244 26.6555 97.3775 25.7348 98.4236 25.7348C99.2387 25.7348 99.9295 26.1429 100.16 26.727L95.9772 28.4639ZM90.8919 33.0003H92.9467V19.2492H90.8919V33.0003ZM87.5237 24.9725H87.4533C86.9924 24.4225 86.1058 23.9264 84.9904 23.9264C82.6507 23.9264 80.5068 25.9823 80.5068 28.6234C80.5068 31.2458 82.6507 33.2841 84.9904 33.2841C86.1069 33.2841 86.9924 32.788 87.4533 32.2215H87.5237V32.8947C87.5237 34.6844 86.5667 35.6414 85.0256 35.6414C83.7672 35.6414 82.9873 34.7383 82.6683 33.976L80.8786 34.7207C81.3923 35.9604 82.7563 37.485 85.0256 37.485C87.4357 37.485 89.474 36.0671 89.474 32.6109V24.2113H87.5248V24.9725H87.5237ZM85.1675 31.4416C83.7496 31.4416 82.5627 30.2536 82.5627 28.6234C82.5627 26.9745 83.7496 25.77 85.1675 25.77C86.5667 25.77 87.6656 26.9745 87.6656 28.6234C87.6656 30.2536 86.5667 31.4416 85.1675 31.4416ZM111.987 19.2492H107.068V33.0003H109.12V27.7907H111.985C114.26 27.7907 116.498 26.144 116.498 23.5205C116.498 20.897 114.261 19.2492 111.987 19.2492ZM112.039 25.8767H109.12V21.1632H112.039C113.574 21.1632 114.445 22.4337 114.445 23.5205C114.445 24.5853 113.574 25.8767 112.039 25.8767ZM124.725 23.9022C123.238 23.9022 121.7 24.5567 121.063 26.0076L122.884 26.7677C123.274 26.0076 124 25.759 124.76 25.759C125.821 25.759 126.9 26.3959 126.918 27.5278V27.6697C126.546 27.4574 125.75 27.1395 124.777 27.1395C122.814 27.1395 120.814 28.2186 120.814 30.2349C120.814 32.0752 122.424 33.2599 124.228 33.2599C125.608 33.2599 126.369 32.6406 126.846 31.9146H126.917V32.9761H128.899V27.7038C128.9 25.264 127.076 23.9022 124.725 23.9022ZM124.476 31.4383C123.805 31.4383 122.867 31.1017 122.867 30.2701C122.867 29.2086 124.035 28.8016 125.044 28.8016C125.944 28.8016 126.37 28.9963 126.918 29.2614C126.758 30.5363 125.662 31.4383 124.476 31.4383ZM136.117 24.2025L133.764 30.1645H133.694L131.252 24.2025H129.041L132.703 32.535L130.615 37.1704H132.756L138.4 24.2025H136.117ZM117.631 33.0003H119.682V19.2492H117.631V33.0003Z",
    fill: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1598 11.267C52.1598 12.1888 51.887 12.9225 51.3403 13.4703C50.7199 14.1215 49.9103 14.4471 48.9159 14.4471C47.9633 14.4471 47.1526 14.1171 46.4871 13.4571C45.8205 12.796 45.4872 11.9776 45.4872 11.0008C45.4872 10.0229 45.8205 9.20452 46.4871 8.54452C47.1526 7.88342 47.9633 7.55342 48.9159 7.55342C49.3889 7.55342 49.841 7.64582 50.27 7.82952C50.7001 8.01432 51.0444 8.25962 51.3018 8.56652L50.7221 9.14732C50.2854 8.62482 49.6837 8.36412 48.9148 8.36412C48.2196 8.36412 47.619 8.60832 47.1119 9.09672C46.6048 9.58512 46.3518 10.2198 46.3518 10.9997C46.3518 11.7796 46.6048 12.4143 47.1119 12.9027C47.619 13.3911 48.2196 13.6353 48.9148 13.6353C49.6518 13.6353 50.2667 13.39 50.7584 12.8983C51.0774 12.5782 51.2622 12.1327 51.3117 11.5618H48.9148V10.7687H52.1125C52.1455 10.9414 52.1598 11.1075 52.1598 11.267Z",
    fill: "#050505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2309 8.51048H54.2257V10.6027H56.9361V11.3958H54.2257V13.488H57.2309V14.2998H53.3776V7.69978H57.2309V8.51048Z",
    fill: "#050505"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8069 14.2998H59.9588V8.51048H58.1152V7.69978H62.6505V8.51048H60.8069V14.2998Z",
    fill: "#050505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9318 14.2998V7.69978H66.7799V14.2998H65.9318Z",
    fill: "#050505"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.541 14.2998H69.6929V8.51048H67.8493V7.69978H72.3846V8.51048H70.541V14.2998Z",
    fill: "#050505"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9698 13.4473C80.3208 14.1139 79.5145 14.4472 78.5498 14.4472C77.5851 14.4472 76.7788 14.1139 76.1309 13.4473C75.4819 12.7807 75.1585 11.9645 75.1585 10.9998C75.1585 10.0351 75.4819 9.21887 76.1309 8.55227C76.7788 7.88567 77.5851 7.55127 78.5498 7.55127C79.509 7.55127 80.3142 7.88677 80.9654 8.55667C81.6166 9.22657 81.9422 10.0406 81.9422 10.9998C81.9422 11.9645 81.6177 12.7807 80.9698 13.4473ZM76.7568 12.894C77.2452 13.389 77.8425 13.6354 78.5498 13.6354C79.2571 13.6354 79.8555 13.3879 80.3428 12.894C80.8312 12.399 81.0765 11.7676 81.0765 10.9998C81.0765 10.232 80.8312 9.60057 80.3428 9.10557C79.8555 8.61057 79.2571 8.36417 78.5498 8.36417C77.8425 8.36417 77.2452 8.61167 76.7568 9.10557C76.2695 9.60057 76.0242 10.232 76.0242 10.9998C76.0242 11.7676 76.2695 12.399 76.7568 12.894Z",
    fill: "#050505"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1324 14.2998V7.69978H84.1642L87.3718 12.8335H87.4081L87.3718 11.5619V7.69978H88.2199V14.2998H87.3344L83.9783 8.91638H83.942L83.9783 10.188V14.2998H83.1324Z",
    fill: "#050505"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1598 11.267C52.1598 12.1888 51.887 12.9225 51.3403 13.4703C50.7199 14.1215 49.9103 14.4471 48.9159 14.4471C47.9633 14.4471 47.1526 14.1171 46.4871 13.4571C45.8205 12.796 45.4872 11.9776 45.4872 11.0008C45.4872 10.0229 45.8205 9.20452 46.4871 8.54452C47.1526 7.88342 47.9633 7.55342 48.9159 7.55342C49.3889 7.55342 49.841 7.64582 50.27 7.82952C50.7001 8.01432 51.0444 8.25962 51.3018 8.56652L50.7221 9.14732C50.2854 8.62482 49.6837 8.36412 48.9148 8.36412C48.2196 8.36412 47.619 8.60832 47.1119 9.09672C46.6048 9.58512 46.3518 10.2198 46.3518 10.9997C46.3518 11.7796 46.6048 12.4143 47.1119 12.9027C47.619 13.3911 48.2196 13.6353 48.9148 13.6353C49.6518 13.6353 50.2667 13.39 50.7584 12.8983C51.0774 12.5782 51.2622 12.1327 51.3117 11.5618H48.9148V10.7687H52.1125C52.1455 10.9414 52.1598 11.1075 52.1598 11.267Z",
    stroke: "#050505",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2309 8.51048H54.2257V10.6027H56.9361V11.3958H54.2257V13.488H57.2309V14.2998H53.3776V7.69978H57.2309V8.51048Z",
    stroke: "#050505",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8069 14.2998H59.9588V8.51048H58.1152V7.69978H62.6505V8.51048H60.8069V14.2998Z",
    stroke: "#050505",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9318 14.2998V7.69978H66.7799V14.2998H65.9318Z",
    stroke: "#050505",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.541 14.2998H69.6929V8.51048H67.8493V7.69978H72.3846V8.51048H70.541V14.2998Z",
    stroke: "#050505",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9698 13.4473C80.3208 14.1139 79.5145 14.4472 78.5498 14.4472C77.5851 14.4472 76.7788 14.1139 76.1309 13.4473C75.4819 12.7807 75.1585 11.9645 75.1585 10.9998C75.1585 10.0351 75.4819 9.21887 76.1309 8.55227C76.7788 7.88567 77.5851 7.55127 78.5498 7.55127C79.509 7.55127 80.3142 7.88677 80.9654 8.55667C81.6166 9.22657 81.9422 10.0406 81.9422 10.9998C81.9422 11.9645 81.6177 12.7807 80.9698 13.4473ZM76.7568 12.894C77.2452 13.389 77.8425 13.6354 78.5498 13.6354C79.2571 13.6354 79.8555 13.3879 80.3428 12.894C80.8312 12.399 81.0765 11.7676 81.0765 10.9998C81.0765 10.232 80.8312 9.60057 80.3428 9.10557C79.8555 8.61057 79.2571 8.36417 78.5498 8.36417C77.8425 8.36417 77.2452 8.61167 76.7568 9.10557C76.2695 9.60057 76.0242 10.232 76.0242 10.9998C76.0242 11.7676 76.2695 12.399 76.7568 12.894Z",
    stroke: "#050505",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1324 14.2998V7.69978H84.1642L87.3718 12.8335H87.4081L87.3718 11.5619V7.69978H88.2199V14.2998H87.3344L83.9783 8.91638H83.942L83.9783 10.188V14.2998H83.1324Z",
    stroke: "#050505",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3536_5104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4796 8.29173C11.1595 8.63053 10.9703 9.15633 10.9703 9.83723V34.1648C10.9703 34.8468 11.1595 35.3715 11.4796 35.7103L11.561 35.7895L25.1889 22.1616V22.001V21.8404L11.561 8.21143L11.4796 8.29173Z",
    fill: "url(#paint1_linear_3536_5104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7308 26.7057L25.1889 22.1616V22.001V21.8404L29.7319 17.2974L29.8342 17.3557L35.2165 20.4137C36.7532 21.2871 36.7532 22.716 35.2165 23.5905L29.8342 26.6485L29.7308 26.7057Z",
    fill: "url(#paint2_linear_3536_5104)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3536_5104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8342 26.6474L25.1878 22.001L11.4796 35.7103C11.9856 36.2471 12.8227 36.3131 13.7654 35.7785L29.8342 26.6474Z",
    fill: "url(#paint3_linear_3536_5104)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.8342 17.3547L13.7654 8.22466C12.8227 7.68896 11.9856 7.75606 11.4796 8.29286L25.1889 22.0022L29.8342 17.3547Z",
    fill: "url(#paint4_linear_3536_5104)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3536_5104",
    x: 10.9703,
    y: 7.85498,
    width: 25.3987,
    height: 28.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3536_5104"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3536_5104",
    result: "effect2_innerShadow_3536_5104"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3536_5104",
    x: 11.4796,
    y: 22.001,
    width: 18.3546,
    height: 14.147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3536_5104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3536_5104",
    x1: -15.8498,
    y1: 8.61393,
    x2: 8.90198,
    y2: 88.6421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F3F3F3",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F9F9F9",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FDFDFD",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "white",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "white",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3536_5104",
    x1: 23.9809,
    y1: 9.57983,
    x2: 5.52072,
    y2: 28.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3536_5104",
    x1: 37.2169,
    y1: 22.001,
    x2: 10.6014,
    y2: 22.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3536_5104",
    x1: 27.3109,
    y1: 24.5243,
    x2: 2.27658,
    y2: 49.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3536_5104",
    x1: 8.02715,
    y1: 0.194443,
    x2: 19.2057,
    y2: 11.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.afe9476e05383550c2151d911accff86.svg";
export { ForwardRef as ReactComponent };